import React, { HTMLProps, useState } from "react";
import './InputActive.scss';
import { InputBlock } from "Components/Form";
import { InputType } from "Models";

type InputActiveProps = {
  id: string;
  label: string;
  description?: string;
  error?: string;
  hint?: string;
  restrictValues?: (val: any) => any;
} & HTMLProps<HTMLDivElement>;

export const InputActive: React.FC<InputActiveProps> = ({
  id,
  label,
  description,
  error,
  hint,
  restrictValues,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const handleFocus = () => {
    setIsFocused(true);
  };
  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div className="input-container" {...props}>
      <h6 className={(isFocused) ? 'label-active' : 'label'}>{label} {props.required && <span style={{ color: "#BD0707" }}>*</span>}</h6>
      <InputBlock
        id={id}
        name={id}
        className="input"
        type={InputType.Text}
        value={props.value}
        onChange={props.onChange}
        useDiv
        noPaddingMargin
        errors={!!error ? [error] : undefined}
        onFocus={handleFocus}
        onBlur={handleBlur}
        restrictValues={restrictValues}
      />
      {hint && !error && <div className="hint">{hint}</div>}
      {!error && description && (<p className="description">{description}</p>)}
    </div>
  );
};